import { render, staticRenderFns } from "./ActivityMaterialSelectModal.vue?vue&type=template&id=030854f2&scoped=true"
import script from "./ActivityMaterialSelectModal.vue?vue&type=script&lang=js"
export * from "./ActivityMaterialSelectModal.vue?vue&type=script&lang=js"
import style0 from "./ActivityMaterialSelectModal.vue?vue&type=style&index=0&id=030854f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030854f2",
  null
  
)

export default component.exports